/**
 * Enum for different animated loader types used across the application
 */
export enum AnimatedLoaderType {
  ai_loader = 'ai_loader',
  pencel = 'pencil',
  learmo_loader = 'learmo_loader',
}
